<div class="details-container">
    <div class="simple-row">
        <div class="details-row" [ngStyle]="{ gap: showDetails ? '16px' : '32px' }">
            <div class="version-text" data-cy="vessel-folder-version-header">
                {{ 'vessel.page.version.current' | translate: { version: selectedVessel.projectVersion || '' } }}
            </div>

            <ng-container *ngIf="!showDetails && selectedVessel.ownerOid">
                <div class="info-with-button">
                    <div class="user-info-row">
                        <mat-icon svgIcon="lock-profile" class="lock-icon" />
                        <ng-container
                            *ngTemplateOutlet="
                                userInfo;
                                context: {
                                    image: ownerImage,
                                    name: selectedVessel.ownerName,
                                }
                            ">
                        </ng-container>
                        <div *ngIf="isOwnerVessel()">
                            {{ 'vessel.page.owner.you' | translate }}
                        </div>
                    </div>
                    <div
                        *ngIf="!isRunningInElectron && isOwnerVessel()"
                        class="user-button"
                        [ngClass]="{ disabled: !isOwnershipReleasable() }"
                        (click)="releaseOwnership()">
                        {{ 'vessel.page.owner.release' | translate }}
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="!showDetails && vesselEditors.length > 0">
                <div class="user-info-row">
                    {{ 'vessel.page.number-editors.title' | translate: { num: vesselEditors.length } }}
                </div>
            </ng-container>

            <div data-cy="vessel-folder-version-history-button" class="user-button" (click)="openVersionsHistory()">
                {{ 'vessel.page.version.history' | translate }}
            </div>
        </div>
        <mat-icon
            data-cy="vessel-folder-container-min-max-icon"
            svgIcon="arrow-down"
            class="arrow-icon"
            (click)="showDetails = !showDetails"
            [ngStyle]="{
                transform: showDetails ? 'rotate(180deg)' : '',
            }" />
    </div>

    <ng-container *ngIf="showDetails && !selectedVessel.ownerOid">
        <div class="user-info-row" data-cy="vessel-folder-owner-unassigned">
            <mat-icon svgIcon="unlocked" class="lock-icon" data-cy="vessel-folder-unlocked-icon" />

            <div class="info-with-button">
                <div>
                    {{ 'vessel.page.owner.unassigned' | translate }}
                </div>
                <div *ngIf="isOwnershipClaimable()" class="user-button" (click)="claimOwnership()">
                    {{ 'vessel.page.owner.claim' | translate }}
                </div>
            </div>
        </div>
        <div
            class="start-version-button"
            data-cy="vessel-folder-start-version"
            (click)="startNewVersion()"
            *ngIf="newVersionButtonEnabled()">
            {{ 'vessel.page.owner.start-version' | translate }}
        </div>
    </ng-container>

    <ng-container *ngIf="showDetails && selectedVessel.ownerOid">
        <div class="user-container" data-cy="vessel-folder-owner-assigned">
            <div class="details-title">
                {{ 'vessel.page.owner.title' | translate }}
            </div>
            <div class="info-with-button">
                <div class="user-info-row" data-cy="vessel-folder-owner-details">
                    <ng-container
                        *ngTemplateOutlet="
                            userInfo;
                            context: {
                                image: ownerImage,
                                name: selectedVessel.ownerName,
                            }
                        ">
                    </ng-container>
                    <div *ngIf="isOwnerVessel()">
                        {{ 'vessel.page.owner.you' | translate }}
                    </div>
                </div>
                <div
                    *ngIf="!isRunningInElectron && isOwnerVessel()"
                    class="user-button"
                    [ngClass]="{ disabled: !isOwnershipReleasable() }"
                    (click)="releaseOwnership()">
                    {{ 'vessel.page.owner.release' | translate }}
                </div>
            </div>
        </div>
        <div class="user-container" data-cy="vessel-folder-req-access-editor-list" *ngIf="vesselEditors.length > 0">
            <div class="details-title">
                {{ 'vessel.page.editor.title' | translate }}
            </div>
            <div class="user-info-row" *ngFor="let editor of vesselEditors">
                <ng-container
                    *ngTemplateOutlet="
                        userInfo;
                        context: {
                            image: editor.image,
                            name: editor.name,
                            editor: editor,
                        }
                    ">
                </ng-container>
            </div>
        </div>

        <ng-container *ngIf="isOwnerVessel() && isEditingVessel()">
            <div class="user-container">
                <div
                    *ngIf="isGuestEditing()"
                    class="user-info-row"
                    data-cy="vessel-folder-req-access-version-lock-reason">
                    {{ 'vessel.page.request-approval.message' | translate }}
                    <div
                        class="highlighted-message"
                        data-cy="vessel-folder-req-access-why-button"
                        (click)="openWhyMessage()">
                        {{ 'vessel.page.request-approval.button' | translate }}
                    </div>
                </div>
                <div *ngIf="!isGuestEditing()" class="user-info-row">
                    {{ 'vessel.page.button.request-approval.message' | translate }}
                </div>
                <div class="simple-row">
                    <ng-container *ngIf="!isRunningInElectron; else finishVersionDiv">
                        <div
                            class="approval-container"
                            data-cy="vessel-folder-request-approval-button"
                            (click)="requestApproval()"
                            [ngClass]="{ 'disable-button': isGuestEditing() }">
                            <mat-icon svgIcon="approval" class="approval-icon" />
                            <div data-cy="vessel-folder-request-approval-button-text">
                                {{ 'vessel.page.button.request-approval' | translate }}
                            </div>
                        </div>
                    </ng-container>

                    <ng-template #finishVersionDiv>
                        <div class="approval-container" (click)="finishVersion()">
                            <mat-icon svgIcon="approval" class="approval-icon" />
                            <div>
                                {{ 'vessel.page.button.finish-version' | translate }}
                            </div>
                        </div>
                    </ng-template>

                    <div
                        class="user-button"
                        data-cy="vessel-folder-delete-version"
                        (click)="deleteVersion()"
                        [ngClass]="{ 'disable-simple': isGuestEditing() }">
                        {{ 'vessel.page.version.delete' | translate }}
                    </div>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="!isOwnerVessel()">
            <div class="user-container">
                <div class="user-info-row">
                    {{ 'vessel.page.owner.request-access.title' | translate }}
                </div>
                <div class="request-buttons-container">
                    <div
                        class="request-access"
                        data-cy="vessel-folder-request-access-button"
                        *ngIf="isEditingVessel() && !accessRequested"
                        (click)="requestVesselAccess()">
                        {{ 'vessel.page.owner.request-access.button' | translate }}
                    </div>
                    <div class="request-access" (click)="requestOwnership()" *ngIf="isOwnershipRequestable()">
                        {{ 'vessel.page.owner.request-ownership.button' | translate }}
                    </div>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="isPendingApproval()">
            <div class="user-info-row">
                <mat-icon svgIcon="lock" class="lock-icon" />
                <div class="user-info-row">
                    {{ 'vessel.page.owner.in-review' | translate }}
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="isApproved() && !accessRequested">
            <div class="user-info-row">
                <mat-icon svgIcon="lock" class="lock-icon" />
                <div class="user-info-row">
                    {{ 'vessel.page.owner.approved' | translate }}
                </div>
            </div>
        </ng-container>
    </ng-container>
</div>

<ng-template #userInfo let-image="image" let-name="name" let-editor="editor">
    <img [src]="image" class="profile-picture" />
    <div data-cy="vessel-folder-vessel-page-account-name">{{ name }}</div>
    <div
        *ngIf="isOwnerVessel() && editor"
        class="user-button"
        data-cy="vessel-folder-req-access-remove-button"
        (click)="removeUser(editor)">
        {{ 'vessel.page.editor.remove' | translate }}
    </div>
    <div
        *ngIf="!isOwnerVessel() && editor?.oid === currentUser.oid"
        class="user-button"
        data-cy="vessel-folder-req-access-leave-button"
        (click)="leaveEditing(editor?.requestId)">
        {{ 'vessel.page.guest.leave-access' | translate }}
    </div>
</ng-template>

<app-confirmation-window
    #ownershipReleaseConfirmationDialog
    [mainLabel]="'vessel.page.ownership.release.dialog.title'"
    [subLabel]="'vessel.page.ownership.release.dialog.message'"
    [discardLabel]="'vessel.page.ownership.release.dialog.cancel'"
    [saveLabel]="'vessel.page.ownership.release.dialog.release'"
    [allButtonsLeft]="true"></app-confirmation-window>

<app-confirmation-window
    #ownershipRequestConfirmationDialog
    [mainLabel]="'vessel.page.ownership.request.dialog.title'"
    [subLabel]="'vessel.page.ownership.request.dialog.message'"
    [discardLabel]="'vessel.page.ownership.request.dialog.cancel'"
    [saveLabel]="'vessel.page.ownership.request.dialog.request'"
    [allButtonsLeft]="true"
    [(comment)]="requestComment"
    [maxLength]="REQUEST_COMMENT_MAX_LENGTH"></app-confirmation-window>

<app-confirmation-window
    #claimOwnershipConfirmationDialog
    [mainLabel]="'vessel.page.message.ownership.claim.dialog.title'"
    [subLabel]="'vessel.page.message.ownership.claim.dialog.message'"
    [discardLabel]="'vessel.page.message.ownership.claim.dialog.cancel'"
    [saveLabel]="'vessel.page.message.ownership.claim.dialog.claim'"
    [allButtonsLeft]="true"></app-confirmation-window>

<ng-container *ngIf="isLoading"> <app-loading-spinner></app-loading-spinner></ng-container>
